import { RenderableGroup } from './renderable-group';

export class RenderableMatrixGroup extends RenderableGroup {
}
